/* @flow */
import * as React from 'react';
import CanvasLTI from 'admin/components/CanvasLTI';
import LTISuccess from 'admin/components/LTISuccess';
import LTIContainer from 'admin/containers/LTIContainer';
import OtherLTI from 'admin/components/OtherLTI';
import SchoologyLTI from 'admin/components/SchoologyLTI';
import OrganizationIntegrationPermissions from 'admin/components/OrganizationIntegrationPermissions';

type State = {
  success: boolean,
};

type Props = {
  params: {
    providerKey: string,
    organizationUUID: string,
  },
};

function NotFound() {
  return <div>error</div>;
}

class LTIPage extends React.Component<Props, State> {
  state: State = {
    success: false,
  };

  handleDone = () => {
    this.setState({ success: true });
  };

  getViewComponent = (key: string) => {
    // prettier-ignore
    switch (key) {
      case 'canvas': return CanvasLTI;
      case 'schoology': return SchoologyLTI;
      case 'other': return OtherLTI;
      default: return NotFound;
    }
  };

  getTitle = (key: string) => {
    // prettier-ignore
    switch (key) {
      case 'canvas': return 'Canvas';
      case 'schoology': return 'Schoology';
      case 'other': return 'Other';
      default: return NotFound;
    }
  };

  getIconURL = (key: string) => {
    // prettier-ignore
    switch (key) {
      case 'canvas': return require('assets/images/canvas.svg');
      case 'schoology': return require('assets/images/schoology.svg');
      case 'other': return undefined;
      default: return NotFound;
    }
  };

  render() {
    return (
      <OrganizationIntegrationPermissions organizationUUID={this.props.params.organizationUUID}>
        {({ loading, canEdit }) => {
          if (loading || !canEdit) {
            return null;
          }

          return (
            <LTIContainer
              serviceKey={this.props.params.providerKey}
              organizationUUID={this.props.params.organizationUUID}>
              {({ lti, rotateCredentials, deleteLTI, loading: ll }) => {
                if (ll) {
                  return null;
                }

                if (this.state.success) {
                  return (
                    <LTISuccess
                      name={this.getTitle(this.props.params.providerKey)}
                      iconURL={this.getIconURL(this.props.params.providerKey)}
                    />
                  );
                }

                const Component = this.getViewComponent(this.props.params.providerKey);

                return (
                  <div className="CanvasLTIPage">
                    <Component
                      lti={lti}
                      deleteLTI={deleteLTI}
                      onDone={this.handleDone}
                      rotateCredentials={rotateCredentials}
                    />
                  </div>
                );
              }}
            </LTIContainer>
          );
        }}
      </OrganizationIntegrationPermissions>
    );
  }
}

export default LTIPage;
